module.exports = __webpack_public_path__ + "static/media/lentz_bowman_tinnin.ec1dc7b2.jpg";